module.exports = __webpack_public_path__ + "static/carbon-table-sorting-fb6dda72b4fbad337b884437edd0e570.png";